import React from "react";
import PropTypes from "prop-types";

import CallTypeSelect from "../../common/CallTypeSelect";
import CustomerSelect from "../../common/CustomerSelect";
import DepartmentSelect from "../../common/DepartmentSelect";
import UserSelect from "../../common/UserSelect";
import ProjectStatusSelect from "../../common/ProjectStatusSelect";
import ProjectCategorySelect from "../../common/ProjectCategorySelect";

const ProjectProgressReviewListFilters = ({
  show,
  filters,
  handleSubmit,
  handleChange,
  handleSearchChange,
  loading,
  handleReset
}) => {
  const classList = ["project-filters", show ? "is-visible" : ""].join(" ");

  return (
    <div className={classList}>
      <form className="report-filters" onSubmit={handleSubmit}>
        <input
          style={{ height: 38 }}
          placeholder="Search..."
          className="form-control"
          type="search"
          name="search"
          defaultValue={filters.search}
          onChange={({ target: { value } }) => {
            handleSearchChange(value);
          }}
        />
        <ProjectStatusSelect
          isMulti
          value={filters.project_status}
          onChange={handleChange("project_status")}
        />
        <CallTypeSelect
          value={filters.call_type}
          isMulti
          onChange={handleChange("call_type")}
        />
        <CustomerSelect isMulti onChange={handleChange("customer")} />
        <DepartmentSelect
          value={filters.department}
          isMulti
          onChange={handleChange("department")}
        />
        <UserSelect
          isMulti
          value={filters.project_manager}
          placeholder="Project Manager"
          onChange={handleChange("project_manager")}
        />
        <ProjectCategorySelect
          isMulti
          value={filters.category}
          onChange={handleChange("category")}
        />
        <button
          disabled={loading}
          className="btn btn-warning"
          type="button"
          onClick={handleReset}
        >
          Reset
        </button>
      </form>
    </div>
  );
};

ProjectProgressReviewListFilters.propTypes = {
  show: PropTypes.bool,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleSearchChange: PropTypes.func,
  handleReset: PropTypes.func,
  loading: PropTypes.bool,
  filters: PropTypes.object
};
export default ProjectProgressReviewListFilters;
